export const numberFormat = number => ('00' + number).slice(-2)
export const formatTime = time => time.toFixed(2)
